import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>© 2026 Galaxy Brain Entertainment</p>
    </footer>
  );
};

